import { LocalStorageService } from './../../../services/shared/local-storage/local-storage.service';
import { Country, Icountry } from './../../../entities/shared/Country';
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-country-list",
  templateUrl: "./country-list.component.html",
  styleUrls: ["./country-list.component.scss"],
  standalone: false
})
export class CountryListComponent {

  @Output() onCountrySelected: EventEmitter<Icountry> = new EventEmitter();

  get countryList() {
    return this.localStorageService?.getListCountries;
  }
  constructor(private localStorageService: LocalStorageService) { }

  ngOnInit() {
    //console.log('this.countryList', this.countryList);
    if (this.countryList?.length === 1) {
      Promise.resolve().then(() => this.onCountrySelected.emit(this.countryList[0]));
    }
  }
}
